import { render, staticRenderFns } from "./PublishVersion.vue?vue&type=template&id=4a1197ed&"
import script from "./PublishVersion.vue?vue&type=script&lang=js&"
export * from "./PublishVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports